import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { S3RegistrationForm } from './components/S3RegistrationForm';
import { S3RegisterFormSchema, type S3RegisterFormValues } from './S3RegisterFormSchema';

export const RegisterToS3Components: FormDrawerProps<ZodSchema<S3RegisterFormValues>> = {
  zodSchema: S3RegisterFormSchema,
  ContentComponent: S3RegistrationForm,
};
